import { __extends } from "tslib";
import { ValueObject } from '../../../../../base/ddd-types/value-object';
import { CorpVipLevel, VipLevel, VipType, } from '../user-info.interface';
var EnterPriseVipUserInfoObjectValue = /** @class */ (function (_super) {
    __extends(EnterPriseVipUserInfoObjectValue, _super);
    function EnterPriseVipUserInfoObjectValue(vipInfo) {
        var _this = _super.call(this) || this;
        _this.type = VipType.NONE;
        _this.vipLevel = VipLevel.NONE;
        _this.beginTime = 0;
        _this.endTime = 0;
        _this.customInfo = {
            avatarFrame: '',
            badgeUrl: '',
            // B端使用
            corpVipLevel: CorpVipLevel.INVALID_CORP_VIP_LEVEL,
        };
        if (!vipInfo) {
            return _this;
        }
        var defValue = _this.createEmptyVip();
        _this.jsonObj2Class(defValue);
        return _this;
    }
    EnterPriseVipUserInfoObjectValue.prototype.updateVipUserInfo = function (vip) {
        if (!vip) {
            return;
        }
        var vipCustomInfo = this.handleVipCustomInfoFromNet(vip);
        this.jsonObj2Class({
            customInfo: vipCustomInfo,
        });
    };
    EnterPriseVipUserInfoObjectValue.prototype.createEmptyVip = function () {
        return {
            type: VipType.NONE,
            beginTime: 0,
            endTime: 0,
        };
    };
    EnterPriseVipUserInfoObjectValue.prototype.handleVipCustomInfoFromNet = function (vip) {
        var parsedData = {
            avatar_frame_url: '',
            badge_url: '',
            corp_vip_level: CorpVipLevel.INVALID_CORP_VIP_LEVEL,
        };
        try {
            parsedData = JSON.parse(vip);
        }
        catch (error) { }
        var _a = parsedData.avatar_frame_url, avatarFrame = _a === void 0 ? '' : _a, _b = parsedData.badge_url, badgeUrl = _b === void 0 ? '' : _b, _c = parsedData.corp_vip_level, corpVipLevel = _c === void 0 ? CorpVipLevel.INVALID_CORP_VIP_LEVEL : _c;
        return {
            avatarFrame: avatarFrame,
            badgeUrl: badgeUrl,
            corpVipLevel: corpVipLevel,
        };
    };
    return EnterPriseVipUserInfoObjectValue;
}(ValueObject));
export { EnterPriseVipUserInfoObjectValue };
